import React, { useEffect, useState } from "react";
import { createScholarship, getAllLevelWithCount } from "../../Services/MasterService";
import { toast } from "react-toastify";

const AddScholarship = ({ data, onClose, onCloseWithApi }) => {
    const [reqData, setReqData] = useState({
        name: "",
    });
    const [loader, setLoader] = useState(false);
    const [level, setLevel] = useState([]);
    const handleChange = (field, value) => {
        setReqData({ ...reqData, [field]: value })
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoader(true);
        let { ok } = await createScholarship(reqData);
        if (ok) {
            toast.success("Success");
            onCloseWithApi();
        }
        setLoader(false);
    };

    const getLevelCall = async () => {
        let { ok, data } = await getAllLevelWithCount({});
        if (ok) {
            setLevel(data?.records);
        }
    };

    useEffect(() => {
        getLevelCall();
        if (data?.data) {
            setReqData(data?.data)
        }
    }, []);

    return (
        <div
            className="modal custom-modal fade bank-details show"
            id="add_items"
            role="dialog"
            aria-modal="true"
            style={{
                display: "block",
                background: "rgb(0 0 0 / 50%)",
            }}
        >
            <form onSubmit={(e) => handleSubmit(e)}>
                <div className="modal-dialog modal-dialog-centered modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="form-header text-start mb-0">
                                <h4 className="mb-0">{!reqData?.id ? "Add Scholarship" : "Edit Scholarship"}</h4>
                            </div>
                            <button
                                type="button"
                                className="close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={() => onClose()}
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="bank-inner-details">
                                <div className="row">
                                    <div className="col-lg-12 col-md-12">
                                        <div className="form-group">
                                            <label>Provider Name</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Provider Name"
                                                required
                                                value={reqData?.provider_name}
                                                onChange={(e) => handleChange("provider_name", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Provider Type</label>
                                            <select required value={reqData?.provider_type} onChange={(e) => handleChange("provider_type", e.target.value)} class="form-select" aria-label="Default select example">
                                                <option selected>Select</option>
                                                <option value={"Institute"}>Institute</option>
                                                <option value={"Trust"}>Trust</option>
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <label>Applicable For</label>
                                            <select required value={reqData?.applicable_for} onChange={(e) => handleChange("applicable_for", e.target.value)} class="form-select" aria-label="Default select example">
                                                <option selected>Select</option>
                                                <option value={"Male"}>Male</option>
                                                <option value={"Female"}>Female</option>
                                                <option value={"All"}>All</option>
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <label>Amount</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="Amount"
                                                required
                                                value={reqData?.amount}
                                                onChange={(e) => handleChange("amount", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Level</label>
                                            <select required value={reqData?.level} onChange={(e) => handleChange("level", e.target.value)} class="form-select" aria-label="Default select example">
                                                <option selected>Select</option>
                                                {level?.map(obj =>
                                                    <>
                                                        <option value={obj?.id}>{obj?.name}</option>
                                                    </>
                                                )}
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <label>Currency</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Currency"
                                                required
                                                value={reqData?.currency}
                                                onChange={(e) => handleChange("currency", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Deadline Page URL</label>
                                            <input
                                                type="url"
                                                className="form-control"
                                                placeholder="Deadline Page URL"
                                                value={reqData?.deadline_page_url}
                                                onChange={(e) => handleChange("deadline_page_url", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Website</label>
                                            <input
                                                type="url"
                                                className="form-control"
                                                placeholder="Website"
                                                required
                                                value={reqData?.website_url}
                                                onChange={(e) => handleChange("website_url", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Frequency</label>
                                            <select required value={reqData?.frequency} onChange={(e) => handleChange("frequency", e.target.value)} class="form-select" aria-label="Default select example">
                                                <option selected>Select</option>
                                                <option value={"Full"}>Full</option>
                                                <option value={"Annual"}>Annual</option>
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <label>Total Scholarships</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="Total Scholarships"
                                                required
                                                value={reqData?.total_scholarships}
                                                onChange={(e) => handleChange("total_scholarships", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Description</label>
                                            <textarea
                                                type="text"
                                                className="form-control"
                                                placeholder="Description"
                                                value={reqData?.description}
                                                onChange={(e) => handleChange("description", e?.target?.value)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className="bank-details-btn">
                                <button
                                    data-bs-dismiss="modal"
                                    className="btn bank-cancel-btn me-2"
                                    onClick={() => onClose()}
                                    disabled={loader}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="btn bank-save-btn"
                                    disabled={loader}
                                >
                                    {loader ? "Loading..." : "Save"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default AddScholarship;